import { render, staticRenderFns } from "./tongueSquareN.vue?vue&type=template&id=df55b440&"
import script from "./tongueSquareN.vue?vue&type=script&lang=js&"
export * from "./tongueSquareN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports